import UrlService from './UrlService';

export class PrintService {
    public printClickHandler(isHistorized?: boolean) {
        UrlService.openInNewWindow(window.location.pathname, `printMode=enabled${isHistorized ? '&historizedMode=enabled' : ''}`, 'print-standby-report', 'width=1700px,height=1000px');
    }

    public printUrgentClickHandler(isExtended: boolean) {
        UrlService.openInNewWindow('urgent-duty-print', 'printMode=enabled&isExtended=' + isExtended, 'print-urgent-duties', 'width=900px,height=600px');
    }
}
